export const scrollToId = (id) => (e) => {
  if (e) e.preventDefault();
  const el = document.getElementById(id);
  if (!el) return;
  // offset for the fixed header so the section eyebrow stays visible (matches scroll-margin-top: 124px)
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -124, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
